import { createSlice } from "@reduxjs/toolkit";
import { CurrencyResponseDto } from "../../shared/dtos/currency/CurrencyResponseDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

export const currencySlice = createSlice({
  name: "currency",
  initialState: getInitialListState<CurrencyResponseDto>(),
  reducers: {
    ...generateListReducers<CurrencyResponseDto>(),
  },
});

export const currencyActions = currencySlice.actions;
export default currencySlice.reducer;
